import styled from 'styled-components';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Card } from '@atom/card/card';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const Wrapper = styled(Card)`
  min-width: 340px;
`;

export const ListWrapper = styled.div`
  padding-top: 24px;
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
`;

export const Description = styled(Text).attrs({
  paragraph: true,
  level: 'm',
})`
  display: flex;
  align-items: center;
  padding-top: 8px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 64px;
`;

export const ItemTitle = styled(Text).attrs({
  level: 'm',
})`
  width: 160px;
`;

export const ManageLink = styled(Button).attrs({
  type: ButtonTypeEnum.Link,
})`
  display: inline;
  padding: 0;
`;

export const ActiveText = styled(Text).attrs({
  level: 's',
  paragraph: true,
  color: ColorEnum.Black100,
})`
  padding-top: 8px;
`;
